<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">IN MEMORIAM: <em>Ned Ludd</em></p>
<p class="nonindent">…a lunatic living about 1779, who in a fit of rage smashed up two frames belonging to a Leicestershire “stockinger.”</p>
<p class="right">—<em>The Oxford Universal Dictionary</em><br/><br/><br/></p>
<p class="right">Down with all kings but King Ludd.</p>
<p class="right">—Byron</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_ded_r1.vue?f9dd353c